'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { Toaster } from 'sonner';
import { ThemeProvider, useTheme } from '@/contexts/theme-context';

const ThemedToaster = () => {
    const { theme } = useTheme();
    const isDark = theme.themeMode === 'dark';

    return (
        <Toaster
            position="top-right"
            theme={theme.themeMode}
            richColors
            expand={true}
            duration={5000}
            closeButton
            className="font-sans"
            toastOptions={{
                style: isDark
                    ? {
                        background: 'rgba(26, 26, 26, 0.9)',
                        backdropFilter: 'blur(12px)',
                        border: '1px solid rgba(255,255,255,0.12)',
                        color: '#FFFFFF',
                        borderRadius: '16px',
                        padding: '16px',
                        fontSize: '14px',
                        fontWeight: '500',
                        boxShadow: '0 10px 40px -10px rgba(0,0,0,0.5)',
                    }
                    : {
                        background: 'rgba(255, 255, 255, 0.92)',
                        backdropFilter: 'blur(12px)',
                        border: '1px solid rgba(0,0,0,0.10)',
                        color: '#000000',
                        borderRadius: '16px',
                        padding: '16px',
                        fontSize: '14px',
                        fontWeight: '500',
                        boxShadow: '0 10px 40px -10px rgba(0,0,0,0.15)',
                    },
                classNames: {
                    toast: 'group',
                    title: 'font-bold',
                    description: 'text-muted-foreground',
                    actionButton: 'bg-primary text-primary-foreground font-bold hover:bg-primary/90',
                    cancelButton: 'bg-secondary text-secondary-foreground hover:bg-secondary/90',
                    error: 'border-destructive/20 bg-destructive/5 text-destructive',
                    success: 'border-primary/20 bg-primary/5 text-primary',
                    warning: 'border-yellow-500/20 bg-yellow-500/5 text-yellow-600',
                    info: 'border-blue-500/20 bg-blue-500/5 text-blue-600',
                }
            }}
        />
    );
};

export default function Providers({ children }: { children: React.ReactNode }) {
    // Cria o cliente do TanStack Query uma única vez
    const [queryClient] = useState(() => new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 60 * 1000, // Dados ficam "frescos" por 1 minuto
                refetchOnWindowFocus: false, // Não recarrega só de mudar de aba
            },
        },
    }));

    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider>
                {children}
                <ThemedToaster />
            </ThemeProvider>
        </QueryClientProvider>
    );
}
